module.exports = __webpack_public_path__ + "static/media/icon-head.6e399e08.svg";